import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import it from 'vuetify/es5/locale/it';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#3E517A',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        background:"#424242"
      },
    },
  },
    lang: {
      locales: { it },
      current: 'it',
    },
});
